import React from "react";
import styles from "./PayslipTemplateOne.module.css";
import PropTypes from "prop-types";
import { format } from "date-fns";
import ImageWithBasePath from "core/img/imagewithbasebath";

const PayslipTemplateOne = ({ payrollDetails, companyDetails }) => {
  const additionRows = payrollDetails?.additionsList?.length + 1;
  const deductionRows = payrollDetails?.deductionsList?.length || 0;
  console.log(payrollDetails);
  return (
    <div className={styles.payslip}>
      <div className={styles.header}>
        {/* <ImageWithBasePath src="assets/img/logo.png" alt="Logo" /> */}
        <img
          src={`data:image/png;base64,${companyDetails?.companyLogo}`}
          alt="Compnay Logo"
          style={{ width: "110px" }}
        />
        <div className={styles["header-text"]}>
          <h2>{companyDetails?.companyName.toUpperCase()}</h2>
          <p>{payrollDetails?.locationName}</p>
          <h3>
            {companyDetails?.address1} {companyDetails?.address2}{" "}
            {companyDetails?.address3}
          </h3>
          <h3>
            {companyDetails?.country} - {companyDetails?.zipCode}
          </h3>
          <h4>
            Payslip for the period of{" "}
            {format(
              new Date(
                payrollDetails?.processYear,
                payrollDetails?.procesMonth - 1,
                1
              ),
              "MMM"
            )}{" "}
            {format(
              new Date(
                payrollDetails?.processYear,
                payrollDetails?.procesMonth - 1,
                1
              ),
              "yyyy"
            )}
          </h4>
        </div>
      </div>
      <table className={styles.details}>
        <tr>
          <td>Employee ID</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.uniqueID}</td>
          <td>Name</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.fullName}</td>
        </tr>
        <tr>
          <td>Department</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.departmentName}</td>
          <td>Designation</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.designationName}</td>
        </tr>
        <tr>
          <td>Date of Joining</td>
          <td>
            :&nbsp;&nbsp;&nbsp;&nbsp;
            {format(new Date(payrollDetails?.joinDate), "dd-MM-yyyy")}
          </td>
          <td>No.Of Working Days</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.noOfWorkingDays}</td>
        </tr>

        <tr>
          <td>Paymode</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.paymentMode}</td>
          <td>
            {payrollDetails?.salaryType === "Monthly"
              ? "Days Worked"
              : payrollDetails?.salaryType === "Daily"
              ? "Days Worked"
              : payrollDetails?.salaryType === "Hourly"
              ? "Hours Worked"
              : ""}
          </td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.payrollValue}</td>
        </tr>
        <tr>
          <td>Bank Name, Branch</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.bankname}</td>
          <td>Leave Taken Days:</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.leaveTakenInDays}</td>
        </tr>
        <tr>
          <td>Bank Acct/Cheque Number:</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.accountNo}</td>
          <td>OT Working Days</td>
          <td>:&nbsp;&nbsp;&nbsp;&nbsp;{payrollDetails?.noOfOtworkingDays}</td>
        </tr>
      </table>

      <div className={styles["table-section"]}>
        <table className={styles["payslip-table"]}>
          <thead>
            <tr>
              <th>Earnings</th>
              <th style={{ textAlign: "center" }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Basic Salary</td>
              <td style={{ textAlign: "center" }}>
                {Number(payrollDetails?.basicSalary).toFixed(2)}
              </td>
            </tr>
            {/* <tr>
              <td>
                OT Salary <br />
                {payrollDetails?.additionalHours > 0 && (
                  <span style={{ fontSize: "10px" }}>
                    Additional Hours ({payrollDetails?.additionalHours})
                  </span>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {Number(
                  Number(payrollDetails?.otdaySalary) +
                    Number(payrollDetails?.othourlySalary)
                ).toFixed(2)}
              </td>
            </tr> */}
            <tr>
              <td>
                OT Day Salary&nbsp;
                {payrollDetails?.noOfOtworkingDays > 0 && (
                  <span style={{ fontSize: "10px" }}>
                    ({payrollDetails?.noOfOtworkingDays} Days)
                  </span>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {Number(payrollDetails?.otdaySalary).toFixed(2)}
              </td>
            </tr>

            <tr>
              <td>
                OT Hour Salary
                <br />
                {payrollDetails?.additionalHours > 0 && (
                  <span style={{ fontSize: "10px" }}>
                    Additional Hours ({payrollDetails?.additionalHours}{" "}
                    {payrollDetails?.additionalHoursString})
                  </span>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {Number(payrollDetails?.othourlySalary).toFixed(2)}
              </td>
            </tr>
            {/* <tr>
              <td>Day Salary</td>
              <td style={{ textAlign: "center" }}>
                {Number(payrollDetails?.noOfOTWorkingDaysSalary).toFixed(2)}
              </td>
            </tr> */}
            {/* {payrollDetails?.residentialType === "S" && ( */}
            <tr>
              <td>Employer CPF</td>
              <td style={{ textAlign: "center" }}>
                {Number(payrollDetails?.employerCpf).toFixed(2)}
              </td>
            </tr>
            {/* )} */}

            <tr>
              <td>SDL</td>
              <td style={{ textAlign: "center" }}>
                {Number(payrollDetails?.sdlAmount).toFixed(2)}
              </td>
            </tr>

            {payrollDetails?.additionsList
              // ?.filter((pd) => pd.adjustmentName === "Addition")
              .map((pd_a, _k) => (
                <tr key={_k}>
                  <td>{pd_a?.description}</td>
                  <td style={{ textAlign: "center" }}>
                    {Number(pd_a?.amount).toFixed(2)}
                  </td>
                </tr>
              ))}
            <tr className={styles["total-row"]}>
              <td>Total Earnings</td>
              <td style={{ textAlign: "center" }}>
                {/* {Number(payrollDetails?.grossSalary).toFixed(2)} */}
                {Number(payrollDetails?.totalEarning).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </table>

        <table className={styles["payslip-table"]}>
          <thead>
            <tr>
              <th>Deductions</th>
              <th style={{ textAlign: "center" }}>Amount</th>
            </tr>
          </thead>
          <tbody>
            {/* {payrollDetails?.residentialType === "S" && ( */}
            <tr>
              <td>Employee CPF</td>
              <td style={{ textAlign: "center" }}>
                {Number(payrollDetails?.employeeCpf).toFixed(2)}
              </td>
            </tr>
            {/* )} */}
            <tr>
              <td>{payrollDetails?.contributionName}</td>
              <td style={{ textAlign: "center" }}>
                {" "}
                {Number(payrollDetails?.agencyAmount).toFixed(2)}
              </td>
            </tr>
            <tr>
              <td>
                Leave Salary Deduction&nbsp;
                {payrollDetails?.leaveTakenInDays > 0 && (
                  <span style={{ fontSize: "10px" }}>
                    ({payrollDetails?.leaveTakenInDays} Days)
                  </span>
                )}
              </td>
              <td style={{ textAlign: "center" }}>
                {" "}
                {Number(payrollDetails?.leaveSalaryAmount).toFixed(2)}
              </td>
            </tr>

            <tr>
              <td>
                Deduction Hours&nbsp;
                <span style={{ fontSize: "10px" }}>
                  ({payrollDetails?.deductionHours * -1}{" "}
                  {payrollDetails?.deductionHoursString})
                </span>
              </td>
              <td style={{ textAlign: "center" }}>
                {" "}
                {Number(payrollDetails?.extraorlessHourAmount).toFixed(2)}
              </td>
            </tr>

            {payrollDetails?.deductionsList
              // ?.filter((pd) => pd.adjustmentName === "Deduction")
              .map((pd_a, _k) => (
                <tr key={_k}>
                  <td>{pd_a?.description}</td>
                  <td style={{ textAlign: "center" }}>
                    {Number(pd_a?.amount).toFixed(2)}
                  </td>
                </tr>
              ))}

            {/* {Array.from({ length: additionRows - deductionRows }).map(
              (d, id) => (
                <tr key={id}>
                  <td style={{ textAlign: "center" }}> - </td>
                  <td style={{ textAlign: "center" }}>-</td>
                </tr>
              )
            )} */}
            <tr className={styles["total-row"]}>
              <td>Total Deductions</td>
              <td style={{ textAlign: "center" }}>
                {/* {Number(payrollDetails?.totalDeductionAmount).toFixed(2)} */}
                {Number(payrollDetails?.totalDeduction).toFixed(2)}

                {/* {Number(
                  Number(payrollDetails?.employeeCpf) +
                    Number(payrollDetails?.agencyAmount) +
                    Number(payrollDetails?.deduction)
                ).toFixed(2)} */}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={styles.netpay}>
        <p>Net Pay (Rounded)</p>
        <h3>{Number(payrollDetails?.netPay).toFixed(2)}</h3>
        {/* <p>(All figures)</p> */}
      </div>

      <div className={styles.signature}>
        <div>Employer Signature</div>
        <div>Employee Signature</div>
      </div>

      <div className={styles.footer}>
        <p>Generated automatically by Winapp Solutions payroll system.</p>
      </div>
    </div>
  );
};
PayslipTemplateOne.propTypes = {
  payrollDetails: PropTypes.array.isRequired,
  companyDetails: PropTypes.object.isRequired,
};
export default PayslipTemplateOne;
